import React from 'react';
import { ArrowRightIcon } from './icons/ArrowRightIcon';
import calendarIcon from '../assets/calendar.svg';
import stopwatchIcon from '../assets/stopwatch.svg';
import diagramIcon from '../assets/diagram.svg';
import thumbsUpIcon from '../assets/thumbs_up.svg';
import chenImage from '../assets/chen.png';
import ratingStars from '../assets/rating_stars.svg';

const JobSearchResults = ({ content }) => {
  const defaultContent = {
    title: 'What happens when job search is done right',
    description: 'Faster offers, bigger raises, and happier jobs — here’s what users are getting.',
    numbersTitle: 'By the Numbers',
    numbers: [
      {
        title: 'Time to better paying job',
        value: '27 days',
        icon: calendarIcon,
      },
      {
        title: 'Total time invested',
        value: '5 hours',
        icon: stopwatchIcon,
      },
      {
        title: 'Salary increase achieved',
        value: '32%',
        icon: diagramIcon,
      },
      {
        title: 'New job satisfaction rate',
        value: '95%',
        icon: thumbsUpIcon,
      },
    ],
    testimonial: {
      name: 'Emily Chen',
      role: 'Data scientist',
      text: 'You guys said it could happen fast, but that fast? Not even a month had passed and I had multiple offers from tech companies, barely investing any time. They were all great, but my manager quickly offered an even bigger raise to keep me, and I happily accepted. Thank you!',
      rating: '4.5 out of 5 stars',
      image: chenImage,
      showSalaryIncrease: true,
    },
  };

  const testimonialsAlignment =
    content?.modifiers?.testimonial?.alignment === 'center' ? 'items-center' : 'items-start';
  const background = content?.modifiers?.testimonial?.background || 'bg-[#F4FFE7]';

  const pageContent = content ? content : defaultContent;

  return (
    <section className="bg-[#FAFAFA] py-10 md:py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8">
          {/* Left side content */}
          <div className="lg:col-span-5 mb-8 lg:mb-0">
            <h2 className="text-[32px] lg:text-[48px] leading-[40px] lg:leading-[56px] font-semibold mb-4">
              {pageContent.title}
            </h2>
            <p className="font-inter text-base lg:text-lg text-gray-600">{pageContent.description}</p>
          </div>

          {/* Right side content */}
          <div className="lg:col-span-7">
            <div className="lg:flex">
              {/* By the Numbers section */}
              <div className="bg-white rounded-t-2xl lg:rounded-2xl lg:rounded-r-none border-t border-l border-r lg:border lg:border-r-0 border-black/[0.06] mb-0 lg:mb-0 lg:flex-1">
                <div className="py-6 px-4 lg:p-8">
                  <h3 className="text-[24px] lg:text-[32px] leading-[32px] lg:leading-[40px] font-semibold mb-6 lg:mb-8">
                    {pageContent.numbersTitle}
                  </h3>
                  <div className="flex flex-col gap-4 lg:gap-6">
                    {pageContent.numbers.map((number, index) => (
                      <div className="flex items-center gap-3" key={index}>
                        <img src={number.icon} alt="" className="w-6 h-6" />
                        <span className="flex-grow font-inter text-base">{number.title}</span>
                        <span className="font-inter text-base font-semibold leading-6 whitespace-nowrap">
                          {number.value}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Testimonial */}
              <div className="lg:flex-1">
                <div
                  className={`${background} rounded-b-2xl lg:rounded-2xl lg:rounded-l-none border-b border-l border-r lg:border lg:border-l-0 border-[#F4FFE7] p-6 h-full`}
                >
                  <div className={`flex ${testimonialsAlignment} gap-3 mb-3`}>
                    <img
                      src={pageContent.testimonial.image ?? chenImage}
                      alt={pageContent.testimonial.name ? pageContent.testimonial.name : 'Emily Chen'}
                      className="w-12 h-12 rounded-full object-cover"
                    />
                    <div>
                      <div className="font-inter font-semibold">{pageContent.testimonial.name}</div>
                      <div className="font-inter text-gray-600">{pageContent.testimonial.role}</div>
                    </div>
                    <div className="ml-auto">
                      <img
                        src={pageContent?.testimonial?.ratingImg || ratingStars}
                        alt="4.5 out of 5 stars"
                        className="w-[104px] h-5"
                      />
                    </div>
                  </div>
                  <p className="font-inter text-gray-700 mb-4">{pageContent.testimonial.text}</p>
                  {pageContent.testimonial.showSalaryIncrease && (
                    <div className="flex items-center gap-2">
                      <ArrowRightIcon />
                      <span className="text-[#19B361] font-inter text-base font-semibold leading-[20px] tracking-[-0.3px] [font-feature-settings:'liga'_off,'clig'_off]">
                        Secured 32% higher salary
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JobSearchResults;
